import { getCookie } from "cookies-next";

const UTM_SOURCE_LIST = ["blog", "newsletter"];

export const getSource = (): string | null => {
  // 1. cnb_i_type 키 값으로 유입된 빌더가 존재하는 경우.
  const integrationType = getCookie("cnb_i_type");
  if (integrationType) {
    return integrationType;
  }

  /**
   * 2. utm_source에 따라서 source를 결정한다.
   * utm_source: blog -> source: blog
   * utm_source: newsletter -> source: newsletter
   */
  try {
    const utmData = getCookie("utm_data");
    const decodedUtmData = utmData ? JSON.parse(utmData) : null;
    if (decodedUtmData) {
      const utmSource = decodedUtmData.utm_source;
      const targetUtmSource = UTM_SOURCE_LIST.find(
        (item) => item === utmSource
      );

      return targetUtmSource ?? null;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to parse utm data from cookie", e);
    return null;
  }

  return null;
};
